module.exports = __webpack_public_path__ + "static/media/banner_juridicofacil_guia.5e9e92e3.png";